import api from "@/services/api.service";
import { required ,email, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      caption:"Edit User",
      campaigns:[],
      formField:{first_name:'',last_name:'',role_id:'',email:'',phone:''},
      submitStatus: null,
      roles:[],
      permission_edit: false,
      superAdmin: false          
    }
  },
  computed: {    
  },
  watch:{          
  },
  mounted () {
  },
  validations: {
    formField: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      role_id:{
        required
      },
      email:{
        required,email
      },
      phone:{
        required, maxLength: maxLength(14)
      }
    }
  },
  async created(){   
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("edit_user") == true){     
              this.getUser();
              this.getRoles();
              this.permission_edit = permissions.includes("edit_user");
            }else if(response.data[0].role == 'super_admin'){
              this.getUser();
              this.getRoles();
              this.superAdmin = true;
            }else if(permissions.includes("list_user") == true || permissions.includes("add_user") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'User List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }  
  },
  methods: {
    acceptNumber(e) {       
      if(e){
        let char = String.fromCharCode(e.keyCode);        
        if(/^[A-Za-z]+$/.test(char)) {
          e.preventDefault(); }
        else {
        var x = this.formField.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,5})/);
        this.formField.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');        
        }
      }
    },
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },      
    async getRoles() {
      let response = await api.post("role/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.data.forEach(
          function(e) {            
            this.roles.push({ value: e.id, text: e.role });
          }.bind(this)
          );
      }
    },    
    async getUser(){        
      let response = await api.post('/users/list',{'id':this.$route.params.id});
      if(!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status == 'success'){
        this.formField = response.data;  
      }else{
       this.makeToast(response.message,'Alert','danger');
     }
   },
   async edit(){
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.submitStatus = 'ERROR'
    } else{
      let response = await api.post('admin/users/update', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        this.makeToast(response.message,'Success','success');
        this.$router.push({name:"User List"})
      }else{
        for(var error in response.errors){
          this.makeToast(response.errors[error],'Alert','danger');
        }
      }
    }
  }
}
}


